import React, { useEffect, lazy, Suspense } from "react";
import "./App.css";
import "react-quill/dist/quill.snow.css";

import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Award from "./components/Award/Award";

import ScrollToTop from "./components/ScrollToTop";

// Redux
import { loadUser } from "./actions/userActions";
import store from "./store";

/* =======================
   LAZY LOAD ALL PAGES
======================= */

// PUBLIC
const Home = lazy(() => import("./components/Home/Home"));
const About = lazy(() => import("./components/About/About"));
const Contact = lazy(() => import("./components/Contact/Contact"));
const Support = lazy(() => import("./components/Support/Support"));
// const Dealer = lazy(() => import("./components/Dealership/Dealer"));
const TollFree = lazy(() => import("./components/Toll free/TollFree"));

const Privacypolicy = lazy(() => import("./components/Privacy-policy"));
const Termconditions = lazy(() => import("./components/Term-conditions"));
const Disclaimer = lazy(() => import("./components/disclaimer"));
const ReturnsRefunds = lazy(() => import("./components/Returns-Refunds"));

// PRODUCTS
const HomeAppliances = lazy(() => import("./components/HomeAppliances/HomeAppliances"));
const HomeAppliancesDetails = lazy(() => import("./components/HomeAppliances/HomeAppliancesPage"));
const HomeApp = lazy(() => import("./components/HomeAppliances/HomeApp"));

const KitchenAppliances = lazy(() => import("./components/KitchenAppliances/KitchenAppliances"));
const KitchenAppliancesDetails = lazy(() => import("./components/KitchenAppliances/KitchenAppliancesPage"));
const KitchenApp = lazy(() => import("./components/KitchenAppliances/KitchenApp"));

const DiwaliPage = lazy(() => import("./components/Header/Diwali"));

// AUTH
const AdminLogin = lazy(() => import("./components/auth/Login/Login"));
const LoginWithOTP = lazy(() => import("./components/auth/LoginOtp/LoginOtp"));
const Registration = lazy(() => import("./components/auth/Register/Register"));

// USER
const Profile = lazy(() => import("./components/UserProfile/Profile"));
const UserProfile = lazy(() => import("./components/UserProfile/userProfile"));
const UpdateProfile = lazy(() => import("./components/User/UpdateProfile"));
const UpdatePassword = lazy(() => import("./components/User/UpdatePassword"));
const ForgotPassword = lazy(() => import("./components/User/ForgotPassword"));
const ResetPassword = lazy(() => import("./components/User/ResetPassword"));

// BLOG
const BlogList = lazy(() => import("./components/BlogPage/BlogList"));
const BlogPage = lazy(() => import("./components/BlogPage/BlogPage"));
// const Award = lazy(() => import("./components/Award/Award"));

// ADMIN
const Dashboard = lazy(() => import("./components/admin/Dashboard"));
const AllUser = lazy(() => import("./components/admin/AllUser"));
const UserUpdate = lazy(() => import("./components/admin/UserUpdate"));
const AdminBlogs = lazy(() => import("./components/admin/AdminBlogs"));
const EditBlog = lazy(() => import("./components/admin/EditBlog"));
const AdminComplaints = lazy(() => import("./components/admin/Complaints"));
const ComplaintDetail = lazy(() => import("./components/admin/ComplaintDetail"));
const CreateStore = lazy(() => import("./components/admin/CreateStore"));
const StoreList = lazy(() => import("./components/admin/StoreList"));
const StorePage = lazy(() => import("./components/admin/StorePage"));

// SUB ADMIN
const SubAdminDashboard = lazy(() => import("./components/SubAdmin/SubAdminDashboard"));
const CreateBlog = lazy(() => import("./components/SubAdmin/CreateBlogs/CreateBlog"));
const BlogDetails = lazy(() => import("./components/SubAdmin/BlogDetails/BlogDetails"));
const UploadImageDashboard = lazy(() => import("./components/SubAdmin/UploadImage/UploadImageDashboard"));
const UploadImage = lazy(() => import("./components/SubAdmin/UploadImage/UploadImage"));
const GetAllImage = lazy(() => import("./components/SubAdmin/UploadImage/GetAllImage/GetAllImage"));

// COMPLAINT
const CreateComplaint = lazy(() => import("./components/ComplaintForm/CreateComplaint"));
const MyComplaints = lazy(() => import("./components/ComplaintForm/MyComplaints"));
const ComplaintTracking = lazy(() => import("./components/ComplaintForm/ComplaintTracking"));

// STORE
const StoreComplaints = lazy(() => import("./components/StoreManager/StoreComplaints"));
const StoreComplaintDetail = lazy(() => import("./components/admin/StoreComplaintDetail"));

//Popup
// const PopupModal = lazy(() => import("./components/PopupModal/PopupModal"));ComboPage
// const PopupModal = lazy(() => import("./components/PopupModal/PopupModal"));
// const ComboPage = lazy(() => import("./components/ComboData/ComboData"));
// const ComboCard = lazy(() => import("./components/ComboData/ComboCard"));
// const ComboPageDetails = lazy(() => import("./components/ComboData/ComboPageDetails"));


const App = () => {
  const location = useLocation();

  const adminPaths = ["/dashboard", "/admin", "/dashboard-subAdmin"];

  const isAdminPage = adminPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  useEffect(() => {
    const authType = localStorage.getItem("authType");
    if (authType === "USER" || authType === "ADMIN") {
      store.dispatch(loadUser());
    }
  }, []);

  return (
    <>
      <Navbar />

      <Suspense fallback={<div className="h-screen flex items-center justify-center text-xl font-bold">Loading...</div>}>
        
        {/* <Dealer /> */}
         <TollFree/>

        <Toaster position="top-right" />

        <ScrollToTop>
          <Routes>

            {/* PUBLIC */}
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/support" element={<Support />} />

            {/* PRODUCTS */}
            <Route path="/luxury-appliances" element={<HomeAppliances />} />
            <Route path="/luxury-appliances/:id" element={<HomeAppliancesDetails />} />
            <Route path="/luxury-appliances/:id/:itemId/:route" element={<HomeApp />} />

            <Route path="/small-appliances" element={<KitchenAppliances />} />
            <Route path="/small-appliances/:id" element={<KitchenAppliancesDetails />} />
            <Route
  path="/small-appliances/:id/:itemId/:route"
  element={<KitchenApp key={window.location.pathname} />}
/>

            <Route path="/diwali-offer" element={<DiwaliPage />} />

            {/* LEGAL */}
            <Route path="/privacy-policy" element={<Privacypolicy />} />
            <Route path="/terms-conditions" element={<Termconditions />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/return-refunds" element={<ReturnsRefunds />} />

            {/* AUTH */}
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/login-with-otp" element={<LoginWithOTP />} />
            <Route path="/register" element={<Registration />} />

            {/* USER */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/user-profile" element={<UserProfile />} />
            <Route path="/me/update" element={<UpdateProfile />} />
            <Route path="/password/update" element={<UpdatePassword />} />
            <Route path="/password/forgot" element={<ForgotPassword />} />
            <Route path="/password/reset/:token" element={<ResetPassword />} />

            {/* BLOG */}
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blog/:id" element={<BlogPage />} />
            <Route path="/awards" element={<Award />} />

            {/* COMPLAINT */}
            <Route path="/complaint/new" element={<CreateComplaint />} />
            <Route path="/my-complaints" element={<MyComplaints />} />
            <Route path="/complaint/:id" element={<ComplaintTracking />} />

            {/* ADMIN */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/alluser" element={<AllUser />} />
            <Route path="/dashboard/alluser/:id" element={<UserUpdate />} />
            <Route path="/dashboard/AdminBlogs" element={<AdminBlogs />} />
            <Route path="/dashboard/blog/edit/:id" element={<EditBlog />} />
            <Route path="/admin/complaints" element={<AdminComplaints />} />
            <Route path="/admin/complaints/:id" element={<ComplaintDetail />} />
            <Route path="/admin/store/create" element={<CreateStore />} />
            <Route path="/admin/stores" element={<StoreList />} />
            <Route path="/admin/storepage" element={<StorePage />} />
            <Route path="/store/complaint/:id" element={<StoreComplaintDetail />} />

            {/* STORE */}
            <Route path="/store/complaints" element={<StoreComplaints />} />

            {/*Popup*/}
            {/* <Route path="/popup" element={<PopupModal />} />
            <Route path="/combopage" element={<ComboPage />} />
            <Route path="/comboCard" element={<ComboCard />} />
            <Route path="/comboPageDetails" element={<ComboPageDetails />} /> */}

            {/* SUB ADMIN */}
            <Route path="/dashboard-subAdmin" element={<SubAdminDashboard />} />
            <Route path="/admin/create-blog" element={<CreateBlog />} />
            <Route path="/blogs/:id" element={<BlogDetails />} />
            <Route path="/dashboard-subAdmin/upload-Images" element={<UploadImageDashboard />} />
            <Route path="/dashboard-subAdmin/upload-Images/upload" element={<UploadImage />} />
            <Route path="/dashboard-subAdmin/All-Image" element={<GetAllImage />} />

          </Routes>
        </ScrollToTop>

      </Suspense>

      {!isAdminPage && <Footer />}
      <ToastContainer />
    </>
  );
};

export default App;
